import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-organic-sources',
  templateUrl: './help-organic-sources.component.html',
  styleUrls: ['./help-organic-sources.component.scss']
})
export class HelpOrganicSourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
